import BackendError from "../BackendError";
import Loading from "./Loading";
import {useGroupNameQuery} from "../pickup-group/queries.generated";
import {useParams} from "react-router";

export default function PickupGroup() {
    const {groupId} = useParams();

    const {loading, error, data} = useGroupNameQuery({
        variables: {id: parseInt(groupId)},
    });

    if (loading) return <Loading />;

    if (error) return <BackendError error={error} />;

    return <span>{data.groups.items[0].name}</span>;
}
